import { useState } from "react"
import Window from "../Window/Window"
import styles from "./EmailWindow.module.css"
import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"

type Props = {
    onClose: () => void
    isMinimized: boolean
    onToggleMinimize: () => void
}

export default function EmailWindow({
    onClose,
    isMinimized,
    onToggleMinimize,
}: Props) {
    useTranslationUpdate()
    const [showCopied, setShowCopied] = useState(false)

    if (isMinimized) return null

    const handleEmailClick = () => {
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=evelyn.rosaporto@gmail.com`, '_blank')
    }

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText("evelyn.rosaporto@gmail.com")
            setShowCopied(true)
            setTimeout(() => setShowCopied(false), 2000)
        } catch (err) {
            // Silent fail
        }
    }

    return (
        <Window
            title={translations('email.window_title')}
            onClose={onClose}
            isMinimized={isMinimized}
            onToggleMinimize={onToggleMinimize}
            initialPosition={{ x: window.innerWidth / 2 - 400, y: 80 }}
            initialSize={{ width: 670, height: 580 }}
            minSize={{ width: 600, height: 500 }}
            bodyClassName={styles.body}
        >
            <div className={styles.container}>
                <h1 className={styles.title}>{translations('email.title')}</h1>

                <p className={styles.description}>
                    {translations('email.description')}
                </p>

                <div className={styles.imageContainer}>
                    <img
                        src="/images/email_illustration.png"
                        alt="Character with laptop"
                        className={styles.characterImage}
                    />
                </div>

                <div className={styles.contactInfo}>
                    <p className={styles.emailText}>
                        {translations('email.send_email_to')}{" "}
                        <span className={styles.emailWrapper}>
                            <span
                                onClick={handleCopyEmail}
                                className={styles.emailLink}
                                title={translations('email.copy_hint')}
                            >
                                evelyn.rosaporto@gmail.com
                            </span>
                            {showCopied && <span className={styles.copiedTooltip}>{translations('email.copied')}</span>}
                        </span>
                    </p>
                    <p className={styles.orText}>{translations('email.or_press_button')}</p>
                </div>

                <button onClick={handleEmailClick} className={styles.emailButton}>
                    {translations('email.button_text')}
                </button>
            </div>
        </Window>
    )
}